(function () {
  var OPEN_SELECTOR = '[data-open-modal="dressbox-modal"]';
  var MODAL_ID = 'dressbox-modal';
  var DRESSBOX_HANDLE = 'dress-box';
  var DRESSBOX_VARIANT_ID = '42677122236653';
  var DRESSBOX_SELLING_PLAN_ID = '8454045933';
  var lastTrigger = null;

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function showState(dialog, stateName) {
    var states = dialog.querySelectorAll('[data-state]');
    for (var i = 0; i < states.length; i++) {
      states[i].hidden = true;
    }
    var active = dialog.querySelector('[data-state="' + stateName + '"]');
    if (active) {
      active.hidden = false;
      var cta = active.querySelector('.dressbox-modal__cta');
      if (cta && typeof cta.focus === 'function') {
        cta.focus();
      }
    }
  }

  function populateReferring(dialog, trigger) {
    var defaultState = dialog.querySelector('[data-state="default"]');
    if (!defaultState) return;
    var titleInput = defaultState.querySelector('[data-referring-product]');
    var urlInput = defaultState.querySelector('[data-referring-url]');
    if (titleInput) titleInput.value = trigger.getAttribute('data-product-title') || '';
    if (urlInput) urlInput.value = trigger.getAttribute('data-product-url') || '';
  }

  function openModal(trigger) {
    var dialog = getModal();
    if (!dialog || typeof dialog.showModal !== 'function') return;
    lastTrigger = trigger;
    populateReferring(dialog, trigger);

    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        var inCart = false;
        if (cart && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].handle === DRESSBOX_HANDLE) {
              inCart = true;
              break;
            }
          }
        }
        showState(dialog, inCart ? 'in-cart' : 'default');
        dialog.showModal();
      })
      .catch(function () {
        showState(dialog, 'default');
        dialog.showModal();
      });
  }

  function closeModal() {
    var dialog = getModal();
    if (!dialog) return;
    dialog.close();
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest(OPEN_SELECTOR);
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openModal(trigger);
      return;
    }

    var cta = e.target.closest && e.target.closest('.dressbox-modal__cta');
    if (cta) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    var dialog = getModal();
    if (!dialog || !dialog.open) return;

    var closer = e.target.closest && e.target.closest('[data-close-modal]');
    if (closer && dialog.contains(closer)) {
      closeModal();
      return;
    }

    if (e.target === dialog) {
      closeModal();
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.classList && e.target.classList.contains('dressbox-modal__form')
      ? e.target
      : null;
    if (!form) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var refProd = form.querySelector('[data-referring-product]');
    var refUrl = form.querySelector('[data-referring-url]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';

    if (submitBtn) {
      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;
    }

    var body = new FormData();
    body.append('id', DRESSBOX_VARIANT_ID);
    body.append('selling_plan', DRESSBOX_SELLING_PLAN_ID);
    body.append('properties[_Referring Product]', refProd ? refProd.value : '');
    body.append('properties[_Referring URL]', refUrl ? refUrl.value : '');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: body
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (err) { throw err; }); }
        window.location.href = '/cart';
      })
      .catch(function () {
        if (submitBtn) {
          submitBtn.textContent = 'Error — try again';
          submitBtn.disabled = false;
          setTimeout(function () {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 3000);
        }
      });
  }, true);
})();
